<template>
  <div id="container">
    <div id="banner-box">
      <!-- banner区域 -->
      <div class="banner">
          <img class="banner-pic" src="@/assets/img_pc/banner9.png" alt="">
      </div>
     <!-- banner区域 -->
    </div>
    <div class="from">
       <div class="from-left">
         <div class="left-tabs-box">
          <div class="title">{{title}}</div>
          <div class="list-box">
            <div :class="(item.id) == $route.query.ids ? 'active':''" class="list"
                  @click="isPush(item)" v-for="(item,index) in list" :key="index">
                  {{item.name}}
                  <!-- {{$route.meta.title}} -->
            </div>
          </div>
          </div>
        </div>
       <div class="from-right">
          <slot></slot>
       </div>
    </div>
  </div>
</template>

<script>
// import Banners from '../Banners/index.vue'
export default {
  name: 'Container',
  components: { },
  props: {
    list: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      active: 0
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    isPush (obj) {
      this.$router.push({
        path: obj.url,
        query: { ids: obj.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
 .banner{
    max-width: 100%;
    height: 300px;
    .banner-pic{
      max-width: 100%;
      height: 100%;
    }
  }
.from{
  display: flex;
  width: 1200px;
  margin: 0 auto;
  .from-left{
    width: 280px;
    .left-tabs-box{
      width: 280px;
      background: #F5F6F9;
    .title{
      width: 280px;
      height: 100px;
      background: #4E55AF;
      font-size: 24px;
      font-weight: 500;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .list-box{
      .list{
        width: 280px;
        height: 80px;
        background: #F5F6F9;
        font-size: 18px;
        font-weight: 400;
        color: #454545;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .active{
        background:#e5eff4;
        border-left: 5px solid #4E55AF;
        color: #4E55AF;
      }
     }
    }
  }
  .from-right{
    padding: 30px 24px;
    // width: 920px;
  }
}
</style>
